export enum RoutePaths {
  Root = '/',

  // Home
  Home = '/home/select',

  // Auth
  LoginCallback = '/auth-callback',
  Logout = '/logout',
  AuthError = '/auth-error',

  // IA
  Essential = '/essential',
  EssentialDashboard = Essential + '/dashboard',
  EssentialDealsheet = Essential + '/dealsheet/:closedDealId/:dealerId',
  EssentialDealHistory = EssentialDealsheet + '/history/:vin',

  // Mastermind
  // Dealtype can be lease, finance, cash or all.
  PortfolioAll = '/portfolio/all',
  PortfolioLease = '/portfolio/lease',
  Portfolio = '/portfolio/:dealType',
  DealSheet = '/dealsheet/:vin/:dealerId/*',
  DealSheetVin = '/dealsheet/:vin/',
  DealsheetError = '/dealsheet/error',
  TurnDealsheet = DealSheet + '?:turnVin&:turnDealerId',
  CustomerProfile = DealSheet + '/customer-profile',
  CampaignActivity = DealSheet + '/campaign-activity',
  History = DealSheet + '/history',
  PrivateIncentives = DealSheet + '/private-incentives',
  Loyalty = DealSheet + '/loyalty',

  // Reporting
  PerformanceInsights = '/reporting/performance/performanceInsights',
  PrivateIncentiveInSights = '/reporting/private-incentive/privateIncentiveInsights',
  ServicePortfolio = '/reporting/service-portfolio/service-portfolio',

  // Robot Actions
  // Action can be exception, updating-predictions, need-info, not-authorized.
  RobotException = '/robot/:action',

  // Off IP
  OffIp = '/offip',

  // Market Impact
  // Type can be new or used.
  MarketImpact = '/market-impact/:type',
  MarketImpactSummary = '/market-impact-summary',

  // Acquire
  Acquire = '/acquire',
  AcquireProspectProfile = Acquire + '/:leadId/:dealerId',

  // Turn
  Turn = '/turn',
  TurnDetails = Turn + '/details/:vin/:dealerId',

  // PIL
  PrivateIncentiveLookup = '/privateincentivelookup',

  BulkPrint = '/bulk-print',

  // Service Portfolio
  Service = '/service',

  // Store Settings
  Admin = '/admin',
  AdminDashboard = Admin + '/dashboard',
  OfferManager = Admin + '/offer-manager',
  Tradebooks = Admin + '/tradebooks',
  PreownedRates = Admin + '/pre-ownedaprrates',
  DMSMapper = Admin + '/dms',
  CRMMapper = Admin + '/crm',
  UserManagement = Admin + '/users',
  HoursOfOperation = Admin + '/hours',
  DataExport = Admin + '/dataexport',

  // Digital Audience
  DigitalAudience = '/digital-audience',
  DigitalAudienceAccounts = DigitalAudience + '/accounts',
  DigitalAudienceConnectAccount = DigitalAudience + '/connect-account',
  DigitalAudienceAudienceBuilder = DigitalAudience + '/audience-builder',
  DigitalAudienceCustomAudience = DigitalAudience + '/custom-audience',
  DigitalAudienceDashboard = DigitalAudience + '/dashboard',
  DigitalAudienceInsights = DigitalAudience + '/insights',
  DigitalAudienceReporting = DigitalAudience + '/reporting',

  // PWA
  PWA = '/pwa',
  PWARequestAccess = '/request-access',
  PWAError = '/pwaError',
  PWADesktopError = '/pwaDesktopModeError',

  // Invitation
  Invitation = '/invite',

  // Get Mobile App
  GetMobileApp = '/get-mobile-app',
  InvitationMobile = '/invite-mobile-app',

  // Unauthorized
  Unauthorized = '/unauthorized',

  // Recent Deals
  Recent = '/recent',

  // Favorite Deals
  Favorites = '/favorites',

  // Support
  Support = '/support',

  // Your Profile
  YourProfile = '/your-profile',

  // Carfax
  CarfaxCallback = '/carfax-auth-callback',
  // test
  CampaignTest = '/campaign-test',
}
